import type { Party } from '../types';

// Counsel is stored as an ordered list. The singular field remains a legacy
// alias so existing matter graphs and document integrations continue to work.
export function getPartyCounselContactIds(party: Pick<Party, 'counsel_contact_ids' | 'counsel_contact_id'>): string[] {
  const ids = Array.isArray(party.counsel_contact_ids) ? party.counsel_contact_ids : [];
  return Array.from(new Set([...ids, party.counsel_contact_id].filter((id): id is string => Boolean(id))));
}

export function counselFields(contactIds: string[]): Pick<Party, 'counsel_contact_ids' | 'counsel_contact_id'> {
  const uniqueIds = Array.from(new Set(contactIds.filter(Boolean)));
  return {
    counsel_contact_ids: uniqueIds,
    ...(uniqueIds[0] ? { counsel_contact_id: uniqueIds[0] } : {}),
  };
}

export function getPartyParalegalContactIds(party: Pick<Party, 'paralegal_contact_ids'>): string[] {
  return Array.from(new Set((party.paralegal_contact_ids ?? []).filter(Boolean)));
}
